import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ModeProvider } from "@/contexts/ModeContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/toaster";
import ProtectedRoute from "@/components/ProtectedRoute";
import { ThemeProvider } from "@/components/site/ThemeProvider";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import MultiPairDashboard from "@/pages/MultiPairDashboard";
import SinglePairPage from "@/pages/SinglePairPage";
import EnginesPage from "@/pages/EnginesPage";
import TimelinePage from "@/pages/TimelinePage";
import HistoryPage from "@/pages/HistoryPage";
import AlertsPage from "@/pages/AlertsPage";
import SettingsPage from "@/pages/SettingsPage";
import BillingPage from "@/pages/BillingPage";
import AutoTradingPage from "@/pages/AutoTradingPage";
import AdminPage from "@/pages/AdminPage";
import NewsPage from "@/pages/NewsPage";
import StubPage from "@/pages/StubPage";

const protect = (el) => <ProtectedRoute>{el}</ProtectedRoute>;

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ModeProvider>
          <ThemeProvider>
            <Routes>
              {/* Public */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />

              {/* Protected app */}
              <Route path="/dashboard" element={<Navigate to="/dashboard/XAUUSD" replace />} />
              <Route path="/dashboard/:symbol" element={protect(<SinglePairPage />)} />
              <Route path="/engines" element={protect(<EnginesPage />)} />
              <Route path="/timeline" element={protect(<TimelinePage />)} />
              <Route path="/history" element={protect(<HistoryPage />)} />
              <Route path="/alerts" element={protect(<AlertsPage />)} />
              <Route path="/news" element={protect(<NewsPage />)} />
              <Route path="/settings" element={protect(<SettingsPage />)} />
              <Route path="/auto-trading" element={protect(<AutoTradingPage />)} />
              <Route path="/billing" element={protect(<BillingPage />)} />
              <Route path="/admin" element={protect(<AdminPage />)} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster />
          </ThemeProvider>
        </ModeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
